export const menuItems = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Executive Director & President of the Board's Message",
    path: "/message",
  },
  {
    name: "Emergency Food Services",
    path: "/emergency-food-services",
  },
  {
    name: "Family Services Department",
    path: "/family",
  },
  {
    name: "Hamilton Community Food Centre",
    path: "/community",
  },
  {
    name: "Education Department",
    path: "/education",
  },
  {
    name: "Volunteer Services",
    path: "/volunteer",
  },
  {
    name: "Staff & Board",
    path: "/staff-board",
  },
]
